module.exports = __webpack_public_path__ + "static/media/folderActive.c4962d0a.svg";